import React from "react";
import Calendar from "./calendario/index";

const Calendario = () => {
  return (
    <>
      <Calendar />
    </>
  );
};

export default Calendario;

